import { OTPInput, Stack } from '@reelplicate/ui';
import { useId } from 'react';

type CodeFieldProps = {
  value: string;
  onChange: (value: string) => void;
  onComplete?: (code: string) => void;
  error?: string;
  autoFocus?: boolean;
};

/**
 * Figma "Code": the centred "Six-digit code" label over the 3 + 3 OTP Input,
 * with the error message below it.
 */
export function CodeField({
  value,
  onChange,
  onComplete,
  error,
  autoFocus,
}: CodeFieldProps) {
  const id = useId();
  return (
    <Stack gap={2} align="center">
      <label htmlFor={`${id}-input`} id={`${id}-label`} className="text-label-md">
        Six-digit code
      </label>
      <OTPInput
        id={`${id}-input`}
        value={value}
        onChange={onChange}
        onComplete={onComplete}
        autoFocus={autoFocus}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? `${id}-error` : undefined}
      />
      {error && (
        <p id={`${id}-error`} role="alert" className="text-body-sm text-status-danger-fg">
          {error}
        </p>
      )}
    </Stack>
  );
}
